__turbopack_context__.v({
  "component": "style-module-scss-module__EFIxgW__component",
  "dash": "style-module-scss-module__EFIxgW__dash",
  "dash-check": "style-module-scss-module__EFIxgW__dash-check",
  "fillWhite": "style-module-scss-module__EFIxgW__fillWhite",
  "icon-spin": "style-module-scss-module__EFIxgW__icon-spin",
  "pride": "style-module-scss-module__EFIxgW__pride",
  "progressBarStripes": "style-module-scss-module__EFIxgW__progressBarStripes",
  "pulsateScale": "style-module-scss-module__EFIxgW__pulsateScale",
  "shimmer": "style-module-scss-module__EFIxgW__shimmer",
  "smallPulsateScale": "style-module-scss-module__EFIxgW__smallPulsateScale",
  "spin": "style-module-scss-module__EFIxgW__spin",
});
